import Assessment from '../models/Assessment';
import BootstrapField from '../utility/BootstrapField';

export default class Property {
	constructor(data) {
		if (!data) {
			data = {}
		}
		Object.assign(this, {
			rollNumber: new BootstrapField({
				value: data.rollNumber || null
			}),
			isDirtyFlag: false,
			assessment: [],
			totalRebate: data.totalRebate || 0,
		});

		this.isDirty = function() {
			return this.isDirtyFlag;
		}
		this.setDirty = function() {
			this.isDirtyFlag = true;
		}
		this.setClean = function() {
			this.isDirtyFlag = false;
		}

		if (data.assessment instanceof Array) {
			let x = 0;
			for (x = 0; x < data.assessment.length; x++) {
				this.assessment.push(new Assessment(data.assessment[x]));
			}
		} else {
			// lets populate it with default assessments..
			this.assessment.push(new Assessment({
				classType: "residential1",
				hasEducationSupportLevy: false
			}));
		}
	}


	static get getClassOptions() {
		return [
			{
				id: "residential1",
				en: "Residential 1",
				fr: "Residential 1",
				hasEducationSupportLevy: false,
			},
			{
				id: "residential2",
				en: "Residential 2",
				fr: "Residential 2",
				hasEducationSupportLevy: false,
			},
			{
				id: "residential3",
				enName: "Residential 3",
				hasEducationSupportLevy: false,
			},
			{
				id: "farmProperty",
				en: "Farm",
				fr: "Farm",
				hasEducationSupportLevy: false,
			},
			{
				id: "otherProperty",
				en: "Other",
				fr: "Other",
				hasEducationSupportLevy: true,
			},
		];
	}
	static getClassTextEn(classId) {
		if (classId) {
			return this.searchByGroupedId(classId, this.getClassOptions).en;
		}
		return null;
	}
	static getClassTextFr(classId) {
		if (classId) {
			return this.searchByGroupedId(classId, this.getClassOptions).fr;
		}
		return null;
	}

	validate() {
		let flag = true;
		// let errors = [];
		/*
		for (let field in this) {
			if (this[field] instanceof BootstrapField) {
				let result = this[field].validate();
				if (result === false) {
					errors.push(field);
					flag = false;
				}
			}
		}
		*/
		return flag;
	}

	getRawValue() {
		return getRawValue(this);

		function getRawValue(obj) {
			let value = {};

			if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							if (typeof obj[key][arrKey] != "function") {
								value[key].push(getRawValue(obj[key][arrKey]));
							}
						}
					} else {
						if (key == "mapPolyline") {
							value[key] = null;
						} else {
							if (typeof value[key] != "function") {
								if (obj instanceof LaneClosureRequestBlock && key == "sRoute") {
									// we won't be submitting sRoute...
								} else {
									value[key] = getRawValue(obj[key]);
								}
							}
						}
					}
				}
			} else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}

	getValue() {
		return getValue(this);

		function getValue(obj) {
			let value = {};
			if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							value[key].push(getValue(obj[key][arrKey]));
						}
					} else {
						if (key == "mapPolyline") {
							value[key] = null;
						} else {
							if (typeof value[key] != "function") {
								value[key] = getValue(obj[key]);
							}
						}
					}
				}
			} else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}


	hasChanges() {
		return !IsEqual(originalLaneClosureRequestData, this.getRawValue());
	}
	revertChanges() {
		this.constructor(originalLaneClosureRequestData);
	}
	saveChanges() {
		// originalLaneClosureRequestData = CloneDeep(this);
		originalLaneClosureRequestData = this.getRawValue();
	}

	static get calculateLcrTrafficEffectText() {
		let effect = "";

		if (this.affectedStreet.value) {
			effect += this.affectedStreet.value + " ";
		}
		if (this.directionId.value) {
			effect += this.getDirectionText(this.directionId.value);
		}
		effect += ", ";

		if (this.fromStreet.value) {
			effect += this.fromStreet.value + " ";
			effect += " to ";
		}
		if (this.toStreet.value) {
			effect += this.toStreet.value + " ";
		}

		// get each block set...
		if (this.presetBlock) {
			for (let x = 0; x < this.presetBlock[0].lane.length; x++) {
				effect += ", " + this.getLaneText(this.presetBlock[0].lane[x].value);
			}

			for (let x = 0; x < this.presetBlock[0].bicycle.length; x++) {
				effect += ", " + this.getBicycleLaneText(this.presetBlock[0].bicycle[x].value);
			}

			for (let x = 0; x < this.presetBlock[0].sidewalk.length; x++) {
				effect += ", " + this.getSidewalkText(this.presetBlock[0].sidewalk[x].value);
			}
		}
		if (this.toStreet.value) {
			effect += ", " + this.getNatureOfWorkText(this.natureOfWorkId.value);
		}

		return effect;
	}



}